import { Chip } from "@mui/material"
import { translate } from "app/language/service"
import { GEO_TARGETS_TYPES } from "form/model"
import { getGeoTargetTypeColor } from "form/tools/geo-targets-list"
import React from "react"

interface IGeoTargetTypeProps {
  type: GEO_TARGETS_TYPES
  id?: string
}

export const GeoTargetType = React.memo(
  ({ type, id }: IGeoTargetTypeProps): JSX.Element => (
    <Chip
      id={id}
      label={translate(
        type === GEO_TARGETS_TYPES.COORDINATE
          ? "campaign.geo-targets.tab.coordinate.title"
          : `campaign.geo-targets.shape.${type}.title`
      )}
      variant="filled"
      sx={{
        "backgroundColor": getGeoTargetTypeColor(type),
        "height": "1.3rem",
        "minWidth": "7rem",
        "borderRadius": ".3rem",
        "& span": {
          color: "#555b6e"
        }
      }}
    />
  )
)
